import { Link } from 'react-router-dom'
import { Gift } from 'lucide-react'
import { PROMO_CTA } from '../../config/home.config'

export function PromoCTA() {
  return (
    <aside className="w-full lg:w-[340px] shrink-0 rounded-xl overflow-hidden bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-card">
      <div className="p-6 flex items-center gap-4">
        <div className="w-16 h-16 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
          <Gift className="w-9 h-9 text-white" />
        </div>
        <div className="flex-1 leading-tight">
          <div className="text-sm font-medium text-white/90">{PROMO_CTA.title}</div>
          <div className="text-xl font-bold mt-1 whitespace-pre-line">
            {PROMO_CTA.highlight}
          </div>
        </div>
        <Link
          to={PROMO_CTA.ctaTo}
          className="shrink-0 bg-white text-brand-600 hover:bg-brand-50 font-semibold text-sm px-5 py-2.5 rounded-full transition"
        >
          {PROMO_CTA.ctaLabel}
        </Link>
      </div>
    </aside>
  )
}
